<script lang='ts'>
    export let famID: string;
    export let swatchID: number;
    export let a11y:boolean = false;
    export let textContrastData:any = [];
    export let anchorIcon:boolean = false;

    import Icons, {IconColors} from '../components/icons.svelte';
    import {familiesS, lightnessParamsS, prefs, appState} from '../stores';

    // find the index of the correct family
    let index = 0;
    $familiesS.forEach((fam, i) => {
        if (fam.id === famID) {
            index = i;
        }
    });

    $: hex = $familiesS[index].swatchGroup[swatchID].hex;
    let contrastColor:IconColors, oppContrastColor:IconColors; // not sure if this declaration is necessary for svelte, but it sure makes vscode happier
    $: contrastColor = $familiesS[index].swatchGroup[swatchID].luminance > 0.18 ? 'black' : 'white' satisfies IconColors;
    $: oppContrastColor = $familiesS[index].swatchGroup[swatchID].luminance > 0.18 ? 'white' : 'black' satisfies IconColors;

    function exportDataToClipBoard(hex:string) {
		navigator.clipboard.writeText(hex);
        $appState.notifications.push({
            message: hex + ' copied',
            id: $appState.notificationCounter++
        });
        $appState.notifications = $appState.notifications;
    }
</script>

<div class="swatch" class:seperation="{$prefs.swatchSeperation}" class:rounded="{$prefs.swatchRounded}" class:anchor="{anchorIcon}" style={'background-color: #' + hex}>
    <div class="icon-area" style={'background-color: #' + hex}>
        {#if anchorIcon }
            <Icons icon={'anchor'} color={contrastColor}/>
        {/if}
    </div>
    
    {#if a11y && textContrastData.length > 0 }
        {#each textContrastData as item, id }
            <p class="rotate-small" style="color: #{item.color}; font-size:{$prefs.swatchA11yLarge ? '20px' : '16px'}" class:bold="{item.label === 'AAA'}">{item.label}</p>
        {/each}
    {/if}

    <div>
        <button class="small rotate-small hex-p" class:force-show={$prefs.swatchHex} style="color:{contrastColor};background-color:color-mix(in srgb, {oppContrastColor}, transparent 90%)" on:click={() => exportDataToClipBoard(hex)}>
            {hex} 
            <Icons icon={'copy'} color={contrastColor}/>
        </button>
        {#if $prefs.swatchLabel}
            <p class="label" style="color:{contrastColor}">{Math.round($familiesS[index].swatchGroup[swatchID].lightness)}</p>
        {/if}
    </div>
</div>

<style>
    .label {
        padding: 1rem 0;
        font-family: monospace;
    }
    .swatch {
        display: inline-flex;
        flex: 1 1;
        overflow: hidden;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        /* padding: 1rem 0; */
        /* height: 100%; */
        /* display: grid;
        grid-template-rows: repeat(auto-fit, 2rem);
        align-items: center;
        justify-items: center; */
    }
    .seperation {
        margin: 3px;
    }
    .rounded {
        border-radius: 1000px;
    }
    .icon-area {
        padding: 8px;
        height: 1rem;
    }
    p {
        padding: 0.5rem;
        text-align: center;
        margin: 0;
    }
    /* p.small {
        font-size: small;
    } */
    p.bold {
        font-weight: bold;
    }
    .hex-p {
        cursor: copy;
        opacity: 0;
        transition: 0.3s;
        background: none;
        border: none;
        font-family: monospace;
        background-color: color-mix(in srgb, var(--background), transparent 90%);
        margin-bottom: 0;
        display: grid;
        grid-template-columns: auto auto;
    }
    .hex-p:hover, .hex-p:focus {
       /* outline: 2px solid var(--background-offset); */
       /* outline-color: red; */
       outline-width: 2px;
       outline-style: solid;
       opacity: 1;
    }
    .swatch:hover .hex-p {
        opacity: 1;
    }
    .force-show {
        display: block !important;
        opacity: 1 !important;
    }
    @media (max-width: 960px) {
        .rotate-small {
            transform: rotate(90deg);
            padding: 2rem;
        }
        .hex-p {
            display: none;
            padding: 0.5rem;
        }
    }
</style>